import React, { useState, useEffect, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter'

import * as S from './styled'

const noop = () => {}

const Filters = ({
    instance: { headers, columns, setAllFilters, gotoPage },
    onApplyFilters = noop,
    onResetFilters = noop,
    selectedFilters,
    setSelectedFilters,
    showFilterToggle,
    defaultFilters = false,
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [hasSelectedFilters, setHasSelectedFilters] = useState(false)
    const [filterOptions, setFilterOptions] = useState([])
    const path = window.location.pathname
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    useEffect(() => {
        let storedFilters = window.localStorage.getItem(`${user}_filters${path}`)
        if (storedFilters) {
            storedFilters = JSON.parse(storedFilters)
            setSelectedFilters(storedFilters)
        } else if (defaultFilters) {
            const selectedFilters = {}
            Object.keys(defaultFilters).forEach(filter => (selectedFilters[filter] = true))
            setSelectedFilters(selectedFilters)
        }
    }, [])

    useEffect(() => {
        let selected = Object.values(selectedFilters).some(filter => filter === true)
        setHasSelectedFilters(selected)
    }, [selectedFilters])

    useEffect(() => {
        const availableFilters = columns
            .filter(col => {
                return col['Filter'] && col.render('Filter')
            })
            .map(col => {
                return {
                    label: col.Header,
                    value: col.id,
                }
            })

        setFilterOptions(availableFilters)
    }, [columns])

    const handleChange = e => {
        const value = e.target.value
        const filters = {
            ...selectedFilters,
            [value]: !selectedFilters[value],
        }

        window.localStorage.setItem(`${user}_filters${path}`, JSON.stringify(filters))
        setSelectedFilters(filters)
    }

    const filters = headers
        .map(header => {
            return header['Filter'] && header.render('Filter')
        })
        .filter(filter => !!filter)
        .map((filter, i) => <Fragment key={i}>{filter}</Fragment>)

    return filters.length ? (
        <S.FilterContainer>
            <div className="!flex !flex-wrap lg:!flex-nowrap !justify-between">
                <S.FilterManagement className="!items-end !order-2 lg:!order-1">
                    {filters}

                    {hasSelectedFilters && (
                        <div className="!mt-4">
                            <button
                                className="btn btn-outline-success apply-filters"
                                data-testid={`apply-filter-button`}
                                onClick={() => {
                                    onApplyFilters()
                                    gotoPage(0)
                                }}
                            >
                                Apply
                            </button>

                            <button
                                className="btn reset-filters"
                                data-testid={`reset-filter-button`}
                                onClick={() => {
                                    setAllFilters({})
                                    onResetFilters()
                                    gotoPage(0)
                                }}
                            >
                                Reset
                            </button>
                        </div>
                    )}
                </S.FilterManagement>

                {showFilterToggle && (
                    <S.FilterManagement className="!justify-end !order-1 lg:!order-2">
                        <div className="!relative">
                            <S.FiltersButton
                                className="btn btn-sm btn-outline-secondary"
                                type="button"
                                data-testid={`filter-button`}
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                {isOpen ? (
                                    <>
                                        <FontAwesomeIcon icon={faTimes} className="!mr-2" />
                                        Close
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faFilter} className="!mr-2" />
                                        Filters
                                    </>
                                )}
                            </S.FiltersButton>

                            {isOpen && (
                                <S.FiltersList>
                                    {filterOptions.map((option, i) => (
                                        <S.FiltersOption key={i}>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    className="!mr-2"
                                                    checked={selectedFilters[option.value]}
                                                    data-testid={`filter-option-${option.label
                                                        .toLowerCase()
                                                        .replaceAll(' ', '-')}`}
                                                    value={option.value}
                                                    onChange={handleChange}
                                                />
                                                {option.label}
                                            </label>
                                        </S.FiltersOption>
                                    ))}
                                </S.FiltersList>
                            )}
                        </div>
                    </S.FilterManagement>
                )}
            </div>
        </S.FilterContainer>
    ) : null
}

export default Filters
